export class Config {
  public static readonly lsPrefix = 'bm';
}
